import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getCookie } from '@beef/utils';

/**
 * Push order data to data layer.
 * @param event {object} Event data.
 */
export var pushDataLayer = function pushDataLayer(event) {
  if (window.dataLayer) {
    window.dataLayer.push(event);
  }
};

/**
 * Get google analytics client id.
 * @returns {string} GA client id.
 */
export function getGAClientId() {
  var gaCookie = getCookie('_ga');
  if (gaCookie) {
    var ga = gaCookie.split('.');
    if (ga.length === 4) return "".concat(ga[2], ".").concat(ga[3]);
  }
  return '';
}
export var pushInfoBannerEvent = function pushInfoBannerEvent(type, title, url) {
  pushDataLayer({
    event: "banner_".concat(type),
    banner_title: title,
    banner_url: url
  });
};
export var pushBannerViewEvent = function pushBannerViewEvent(_ref) {
  var index = _ref.index,
    id = _ref.id,
    title = _ref.title,
    link = _ref.link;
  pushDataLayer(_defineProperty(_defineProperty(_defineProperty({
    event: 'banner_view'
  }, "banner_id_".concat(index), id), "banner_title_".concat(index), title), "banner_url_".concat(index), link));
};
export var pushFloatingCheckAction = function pushFloatingCheckAction(eventActionKey, eventLabelKey, pushOnce) {
  var eventActionList = {
    address: 'check_adress',
    backCall: 'callback'
  };
  var eventLabelList = {
    open: 'click_to_open',
    connectTariff: 'click_connect',
    backCallOpen: 'click_to_open',
    addressFound: 'address_is_available',
    flatNotAvailable: 'address_is_not_available',
    streetNotFound: 'street_was_not_found',
    houseNotFound: 'house_is_not_available',
    houseFound: 'house_is_available'
  };
  var eventAction = eventActionList[eventActionKey];
  var eventLabel = eventLabelList[eventLabelKey];
  if (pushOnce) {
    var event = window.dataLayer.find(function (eventObj) {
      return eventObj.eventCategory === 'check' && eventObj.eventAction === eventAction && eventObj.eventLabel === eventLabel;
    });
    if (event) return;
  }
  pushDataLayer({
    event: 'GA_event',
    eventCategory: 'check',
    eventAction: eventAction,
    eventLabel: eventLabel
  });
};
var pushFTTBFormAction = function pushFTTBFormAction(eventAction) {
  var eventActionList = {
    street: 'NewStreet',
    house: 'NewHouse',
    flat: 'NewFlat',
    phone: 'Phone',
    name: 'Name'
  };
  pushDataLayer({
    event: 'GA_event',
    eventCategory: 'FTTBForm',
    eventAction: eventActionList[eventAction],
    eventLabel: 'changeField'
  });
};
export var pushFTTBAction = function pushFTTBAction(eventAction, eventLabel, eventCategory) {
  if (eventCategory === 'FTTBForm') {
    pushFTTBFormAction(eventLabel);
    if (!eventAction) return;
  }
  if (!eventCategory && eventAction === 'address') {
    pushFloatingCheckAction(eventAction, eventLabel);
  }
};
export var pushFTTBOrder = function pushFTTBOrder(type, data, services, errorType, orderType, isFttbWithTv) {
  var eventTypes = {
    server: 'event_item_order_sent_server_error',
    double: 'event_item_order_sent_double',
    sentFail: 'event_item_order_sent_fail',
    openOrderPopup: 'event_item_order_open_popup'
  };
  var errorTypes = {
    notFoundHouse: 'not_connected_house'
  };
  var orderTypes = {
    home: 'Home user'
  };
  var eventObj = {
    event: eventTypes[type],
    clientType: 'B2C',
    ordered_itemProduct: isFttbWithTv ? 'FTTBOrderTV' : 'FTTBOrder',
    ordered_itemTitle: data === null || data === void 0 ? void 0 : data.title,
    ordered_itemSoc: data === null || data === void 0 ? void 0 : data.alias,
    ordered_Type: orderTypes[orderType] || '',
    ordered_itemPrice: String(data === null || data === void 0 ? void 0 : data.fee),
    ordered_addServices: services ? services.map(function (s) {
      return s.alias;
    }).join('|') : ''
  };
  if (errorType) {
    eventObj.error_type = errorTypes[errorType];
  }
  pushDataLayer(eventObj);
};
export var pushBackCallAction = function pushBackCallAction(eventAction, eventLabel, additionalData) {
  var eventActionList = {
    shown: 'shown',
    click: 'click_send',
    send: 'form_send',
    sendError: 'form_send_error',
    captcha: 'captcha_shown',
    widget: 'callback_widget',
    buttonClick: 'buttonClick',
    clickInFrom: 'click_Позвоните мне'
  };
  var eventLabelList = {
    linkClick: 'Закажите обратный звонок',
    widgetClick: 'Виджет',
    fmc: 'Convorder',
    fttb: 'FTTBOrder',
    fttbTv: 'FTTBOrderTV',
    url: window.location.href,
    getBeeline: 'get_beeline',
    chosen: 'chosen'
  };
  var pushData = {
    event: 'GA_event',
    eventCategory: 'callback_form',
    eventAction: eventActionList[eventAction],
    eventLabel: eventLabelList[eventLabel]
  };
  if (additionalData) {
    pushData = _objectSpread(_objectSpread({}, pushData), additionalData);
    if (additionalData.ordered_itemProduct) {
      pushData = _objectSpread(_objectSpread({}, pushData), {}, {
        ordered_itemProduct: eventLabelList[additionalData.ordered_itemProduct]
      });
    }
  }
  pushDataLayer(pushData);
};
export var pushCheckAddressAction = function pushCheckAddressAction(eventAction) {
  pushDataLayer({
    event: 'GA_event',
    eventCategory: 'buttonClick',
    eventAction: eventAction
  });
};
export var pushTVEUpsaleBlockAction = function pushTVEUpsaleBlockAction(eventAction) {
  var eventActionList = {
    show: 'show',
    eShopClick: 'click_В интернет-магазин',
    iosClick: 'click_Скачать для iOS',
    androidClick: 'click_Скачать для Android'
  };
  pushDataLayer({
    event: 'GA_event',
    eventCategory: 'TVE_block',
    eventAction: eventActionList[eventAction],
    eventLabel: 'spd_order_form'
  });
};
export var pushFullFormPopupAction = function pushFullFormPopupAction(_ref2) {
  var category = _ref2.category,
    action = _ref2.action;
  var eventCategories = {
    btnClick: 'buttonClick'
  };
  var eventActions = {
    order: 'Оформить заявку'
  };
  pushDataLayer({
    event: 'GA_event',
    eventCategory: eventCategories[category],
    eventAction: eventActions[action]
  });
};

/**
 * Push to dataLayer for Open TariffConnectionPopup With Option
 * @param optionName {string} - Option name: constructor or economy
 */
export var pushTariffOption = function pushTariffOption(optionName) {
  pushDataLayer({
    event: optionName === 'Закрыть popup' ? 'popupClose_Bee' : 'tariffOption_Bee',
    details: {
      flow: 'buttonClick',
      name: optionName
    }
  });
};